import { call, put } from "redux-saga/effects";
import { setPartOffer, setSinglePartOffer } from "../../entities/partOffers";
import { requestGetPartOffer } from "../requests/partOffers";
import { requestReadPartOffer } from "../requests/partOffers";

export function* handleGetPartOffer(action) {
  try {
    const { limit, offset } = action.payload;

    const response = yield call(requestGetPartOffer, { limit, offset });
    if (!response || !response.data) {
      console.error("API odgovor je undefined ili nema podatke");
      return;
    }

    const { data } = response;
    yield put(setPartOffer(data));
  } catch (error) {
    console.error("Greška u handleru:", error);
  }
}



export function* handleReadPartOffer(action) {
  try {
    const { id } = action.payload;

    const response = yield call(requestReadPartOffer, id);

    if (!response || !response.data) {
      console.error("API odgovor je undefined ili nema podatke");
      return;
    }

    const { data } = response;
    yield put(setSinglePartOffer(data));
  } catch (error) {
    console.error("Greška u handleru:", error);
  }
}
